module.exports = __webpack_public_path__ + "img/c-thermometer-img4-2.f237d246.png";